module.exports = __webpack_public_path__ + "assets/img/4d.b85e6402.png";